<template>
  <div v-if="car" ref="car">
    <FsLightbox
			:toggler="toggler"
			:slide="slide"
			:sources="formattedpics"/>
    <div class="container my-md-5 my-4 p-0">
      <div class="row gx-3 crc-single-car-hero">
        <div class="col-12 d-flex flex-column flex-sm-row justify-content-start justify-content-sm-between align-items-start align-items-sm-center">
          <div class="social-share-container mb-2 d-flex align-items-center">
            <a target="_blank" href="#" @click="getPdf" class="btn-social small"><span class="social-text me-2">Brochure</span> <font-awesome-icon class="open-social-icon icon-pdf" :icon="['fas', 'fa-file-pdf']" size="xl" /></a>
            <SocialShare :car="car" :current-model="currentmodel" />

          </div>
          <button v-if="this.$parent.fromArchive == 1" class="btn back-btn mb-2 mb-sm-0 reverse-arrow d-inline-flex flex-row-reverse" onclick="history.back()">Naar overzicht</button>
          <a v-if="this.$parent.fromArchive !== 1" class="btn back-btn mb-2 mb-sm-0 reverse-arrow d-inline-flex flex-row-reverse" href="/aanbod/">Naar overzicht</a>
        </div>
        <div class="col-lg-8 px-0 px-md-2">
          <Carousel id="gallery" :items-to-show="1" :wrap-around="false" v-model="currentSlide" v-bind="settingsCarousel" :breakpoints="breakpoints">
            <Slide v-for="(photo,key,index) in car.photos" :key="photo">
              <div class="carousel__item" @click="openLightboxOnSlide(index)">
                <img :src="photo.large">
              </div>
            </Slide>
          </Carousel>
          <Carousel
              id="thumbnails"
              :items-to-show="4"
              :wrap-around="true"
              v-model="currentSlide"
              :breakpoints="breakpointsSecond"
              ref="carousel"
              class="crc-img-container m-2"
          >
            <Slide v-for="(photo, key) in car.photos" :key="photo">
              <div class="carousel__item" @click="slideTo(key)">
                <img :src="photo.thumb">
              </div>
            </Slide>
          </Carousel>
        </div>
        <div class="col-lg-4 mt-4 mt-lg-0 crc-shadow bg-white">
          <div class="col-inner py-4 px-3 py-md-5 px-md-3">
            <h1 class="blackcolor">{{  car.title }}</h1>
           <p class="blackcolor" v-html="car.mappeddata.type"></p>
            <ul class="list-group list-group-flush car-sidebar-card">
              <li class="list-group-item d-flex flex-wrap justify-content-between align-items-center"><span>Nu voor:</span> <span class="price">{{ formatPrice(car.mappeddata.price) }}</span></li>
              <hr>
              <li v-if="car.extradata.finance_term" class="list-group-item finance-container-detail rounded-2 d-flex flex-wrap justify-content-between align-items-center">
                <span>Financieren p/m v.a.</span> <span class="finance-price badge badge-pill text-white">{{ formatPrice(parseInt(car.extradata.finance_term)) }}</span>
                <a @click.prevent="scrollToCalculator('financiering-berekenen')" href="#" class="d-block">
                  Bereken uw maandbedrag
                </a>
              </li>
              <li v-if="car.extradata.finance_term" class="list-group-item d-flex flex-wrap justify-content-between align-items-center">
                <div class="geld-lenen-kost-geld-container">
                  <img class="geld-lenen-kost-geld__image" src="https://voorraad-app-frontend.crc-connect.nl/build-voorraad/img/geld-lenen-kost-geld.300b48b8.svg" width="250" height="29" alt="Let op! Geld lenen kost geld">
                </div>
              </li>
            </ul>

            <div class="crc-buttons mt-4">
              <template v-for="action in callToActions">
                <a v-if="action.type === 'call'" :href="'tel:' + (carStore.locations && carStore.locations[car.location] && car.location !== undefined  ? carStore.locations[car.location].phone : contact.phone)" class="btn" :key="action.type" :style="{ 'background-color': action.button_color, 'border-color': action.button_color }">
                  <i v-html="action.icon" class="d-inline-block" style="height: 20px; width: 20px; float: left;"></i>
                  <span>{{ action.label }}</span>
                </a>

                <a v-if="action.type === 'testdrive' || action.type === 'tradein' || action.type === 'onlinepayment'" class="btn" v-on:click="scrollTo(action.type)" :key="action.type" :style="{ 'background-color': action.button_color, 'border-color': action.button_color }">
                  <i v-html="action.icon" class="d-inline-block" style="height: 20px; width: 20px; float: left;"></i>
                  <span class="d-inline-flex d-flex align-middle">{{ action.label }}</span>
                </a>

                <a v-if="action.type === 'downpayment' && settings.MollieEnabled" class="btn" data-bs-toggle="collapse" href="#collapseDownpayment" role="button" aria-expanded="false" aria-controls="collapseDownpayment" :key="action.type" :style="{ 'background-color': action.button_color, 'border-color': action.button_color }">
                  <i v-html="action.icon" class="d-inline-block" style="height: 20px; width: 20px; float: left;"></i>
                  <span>{{ action.label }}</span>
                </a>
                <div v-if="action.type === 'downpayment' && settings.MollieEnabled" class="collapse" id="collapseDownpayment" :key="action.type">
                  <div class="card card-body">
                    Door de auto direct aan te betalen wordt de auto van u keuze voor uw gereserveerd.

                    <div class="form-group mt-2 d-none">
                      <label for="downpaymentCarID"><strong>ID:</strong></label>
                      <input type="text" name="downpaymentCarID" class="form-control" :value="car.id">
                    </div>
                    <div class="form-group mt-2">
                      <label for="downpaymentModel"><strong>Merk en model:</strong></label>
                      <input type="text" name="downpaymentModel" class="form-control" v-model="downpaymentForm.merkmodel" required>
                    </div>
                    <div class="form-group mt-2">
                      <label for="downpaymentName"><strong>Naam:</strong></label>
                      <input type="text" name="downpaymentName" v-model="downpaymentForm.naam" class="form-control" required>
                    </div>
                    <div class="form-group mt-2">
                      <label for="downpaymentPhone"><strong>Telefoon:</strong></label>
                      <input type="text" name="downpaymentPhone" v-model="downpaymentForm.tel" class="form-control" required>
                    </div>
                    <div class="form-group mt-2">
                      <label for="downpaymentEmail"><strong>Email:</strong></label>
                      <input type="text" name="downpaymentEmail" v-model="downpaymentForm.email" class="form-control" required>
                    </div>
                    <div class="form-group mt-2">
                      <div class="row">
                        <div class="col-6">
                          <label for="downpaymentTotal">
                            <strong>Totaal: {{ formatPrice(car.mappeddata.price) }}</strong>
                          </label>
                        </div>
                        <div class="col-6">
                          <label for="downpaymentTotal">
                            <strong><img src="@/assets/ideal.png" width="30" /></strong>
                          </label>
                        </div>
                      </div>
                    </div>
                    <button type="submit" class="btn mt-4" @click="doPayment($event)">Aanbetalen</button>
                  </div>
                </div>
                <a v-if="action.type === 'estimate'" class="btn" v-on:click="scrollTo('estimate')" :key="action.type" :style="{ 'background-color': action.button_color, 'border-color': action.button_color }">
                  <i v-html="action.icon" class="d-inline-block" style="height: 20px; width: 20px; float: left;"></i>
                  <span>{{ action.label }}</span>
                </a>
              </template>
            </div>
            <div style="margin-left:-1rem;margin-right:-1rem;" class="ctc-app-container"><div id="ctc-apps"></div></div>
          </div>
        </div>
      </div>
      <div class="row mt-4 py-4 px-3 px-md-0">
        <div class="col-sm-4 d-flex align-items-center px-2" v-if="settings.usp_1">
          <svg class="me-2 whitefill" width="20px" height="20px"><use xlink:href="#Icon--checkmark"></use></svg>
          <p class="m-0">{{ settings.usp_1 ?? '' }}</p>
        </div>
        <div class="col-sm-4 d-flex align-items-center px-2" v-if="settings.usp_2">
          <svg class="me-2 whitefill" width="20px" height="20px"><use xlink:href="#Icon--checkmark"></use></svg>
          <p class="m-0">{{ settings.usp_2 ?? '' }}</p>
        </div>
        <div class="col-sm-4 d-flex align-items-center px-2" v-if="settings.usp_3">
          <svg class="me-2 whitefill" width="20px" height="20px"><use xlink:href="#Icon--checkmark"></use></svg>
          <p class="m-0">{{ settings.usp_3 ?? '' }}</p>
        </div>
      </div>
    </div>

  <!--  Forms  -->
  <!-- Estimate -->
      <form id="estimateForm" :class="{'d-block' : this.selectedForm === 'estimate', 'd-none' : this.selectedForm !== 'estimate'}" class="container my-5" ref="estimate" @submit.prevent="submitestimate">
      <h3>Offerte aanvragen</h3>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="estimateSalutation">Aanhef</label>
            <select v-model="estimateForm.aanhef" class="form-control">
              <option>Dhr.</option>
              <option>Mevr.</option>
            </select>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="estimateFirstname">Voornaam *</label>
            <input v-model="estimateForm.voornaam" type="text" name="estimateFirstname" class="form-control" required>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="estimateInfix">Tussenvoegsel</label>
            <input v-model="estimateForm.tussenvoegsel" type="text" name="estimateInfix" class="form-control">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="estimateLastname">Achternaam *</label>
            <input v-model="estimateForm.achternaam" type="text" name="estimateLastname" class="form-control" required>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <div class="form-group">
            <label for="estimatePhone">Telefoonnummer *</label>
            <input type="text" v-model="estimateForm.telefoonnummer" name="estimatePhone" class="form-control" required>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="estimateEmail">E-mailadres *</label>
            <input v-model="estimateForm.email" type="text" name="estimateEmail" class="form-control" required>
          </div>
        </div>
      </div>

      <div class="form-group mt-4">
        <label for="estimateQuestion">Uw vraag</label>
        <textarea v-model="estimateForm.vraag" class="form-control" name="estimateQuestion" rows="3" required></textarea>
      </div>

      <div class="form-check mt-4">
        <input v-model="estimatetoestemming" type="checkbox" class="form-check-input" id="estimateCheck" required>
        <label class="form-check-label" for="estimateCheck">
          Hierbij geef ik {{ contact.name }} toestemming om mijn gegevens te gebruiken voor het verwerken van dit formulier
        </label>
      </div>

      <button @click="submitestimate($event)" type="submit" class="btn btn-primary mt-4">Versturen</button>
    </form>

  <!-- Testdrive -->
    <form v-if="this.selectedForm === 'testdrive'" class="container my-5" ref="testdrive">
      <h3>Proefrit aanvragen</h3>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="testDriveSalutation">Aanhef</label>
            <select class="form-control" v-model="testdriveForm.aanhef">
              <option>Dhr.</option>
              <option>Mevr.</option>
            </select>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="testDriveFirstname">Voornaam</label>
            <input type="text" v-model="testdriveForm.voornaam" name="testDriveFirstname" class="form-control" required>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="testDriveInfix">Tussenvoegsel</label>
            <input type="text" v-model="testdriveForm.tussenvoegsel" name="testDriveInfix" class="form-control" required>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="testDriveLastname">Achternaam</label>
            <input type="text" v-model="testdriveForm.achternaam" name="testDriveLastname" class="form-control"  required>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <div class="form-group">
            <label for="testDrivePhone">Telefoonnummer</label>
            <input type="text" v-model="testdriveForm.telefoonnummer" name="testDrivePhone" class="form-control" required>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="testDriveEmail">E-mailadres</label>
            <input type="text" v-model="testdriveForm.email" name="testDriveEmail" class="form-control" required>
          </div>
        </div>
      </div>

      <div class="form-group mt-4">
        <label for="testDriveQuestion">Uw vraag</label>
        <textarea class="form-control" v-model="testdriveForm.vraag" name="testDriveQuestion" rows="3" required></textarea>
      </div>

      <div class="form-group mt-4">
        <div class="row mt-4">
          <div class="col">
            <div class="form-group">
              <label for="testDriveDateDay">Gewenste datum</label>
              <div class="d-flex align-items-center">
                <input type="text" v-model="testdriveForm.gewenstedatum" name="testDriveDateDay" class="form-control me-2" style="max-width: 180px;" required>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-check mt-4">
        <input v-model="testdrivetoestemming" type="checkbox" class="form-check-input" id="testDriveCheck" required>
        <label class="form-check-label" for="testDriveCheck">
          Hierbij geef ik {{ contact.name }} toestemming om mijn gegevens te gebruiken voor het verwerken van dit formulier
        </label>
      </div>
      <button type="submit" @click="submittestdrive($event)" class="btn btn-primary mt-4">Versturen</button>
    </form>

    <!-- Trade in -->
    <form v-if="this.selectedForm === 'tradein'" class="container my-5"  ref="tradein">
      <h3>Auto inruilen</h3>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="tradeInSalutation">Aanhef</label>
            <select class="form-control" v-model="tradeinForm.aanhef">
              <option>Dhr.</option>
              <option>Mevr.</option>
            </select>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="tradeInFirstname">Voornaam</label>

            <input type="text" v-model="tradeinForm.voornaam" name="tradeInFirstname" class="form-control" required>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="tradeInInfix">Tussenvoegsel</label>
            <input type="text" v-model="tradeinForm.tussenvoegsel" name="tradeInInfix" class="form-control" required>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="tradeInLastname">Achternaam</label>
            <input v-model="tradeinForm.achternaam" type="text" name="tradeInLastname" class="form-control" required>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col">
          <div class="form-group">
            <label for="tradeInPhone">Telefoonnummer</label>
            <input v-model="tradeinForm.telefoonnummer" type="text" name="tradeInPhone" class="form-control" required>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="tradeInEmail">E-mailadres *</label>
            <input v-model="tradeinForm.email" type="text" name="tradeInEmail" class="form-control" required>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col">
          <div class="form-group">
            <label for="tradeInLicensePlate">Kenteken *</label>
            <input v-model="tradeinForm.kenteken" type="text" name="tradeInLicensePlate" class="form-control" required>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col">
          <div class="form-group">
            <label for="tradeInKM">Kilometerstand *</label>
            <input v-model="tradeinForm.kilometerstand" type="text" name="tradeInKM" class="form-control" required>
          </div>
        </div>
      </div>

      <div class="mt-4">
<!--        <DropZone-->
<!--            :maxFiles="Number(15)"-->
<!--            :uploadOnDrop="false"-->
<!--            :multipleUpload="true"-->
<!--            :parallelUpload="3"-->
<!--        />-->
      </div>

      <div class="form-group mt-4">
        <label for="tradeInQuestion">Opmerkingen</label>
        <input  v-model="tradeinForm.opmerkingen" type="text" class="form-control" name="tradeInQuestion">
      </div>

      <div class="form-check mt-4">
        <input v-model="tradeintoestemming" type="checkbox" class="form-check-input" id="tradeInCheck">
        <label class="form-check-label" for="tradeInCheck">
          Hierbij geef ik {{ contact.name }} toestemming om mijn gegevens te gebruiken voor het verwerken van dit formulier
        </label>
      </div>

      <button type="submit" @click="submittradein($event)" class="btn btn-primary mt-4">Versturen</button>
    </form>

    <!-- Online Payment -->
    <form v-if="this.selectedForm === 'onlinepayment'" class="container my-5"  ref="onlinepayment">
        <h3>Online kopen</h3>
        <h4>1. Persoonsgegevens</h4>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="onlinePaymentSalutation">Aanhef</label>
              <select class="form-control" v-model="onlinepaymentForm.aanhef">
                <option>Dhr.</option>
                <option>Mevr.</option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="onlinePaymentFirstname" >Voornaam</label>

              <input type="text" v-model="onlinepaymentForm.voornaam" name="onlinePaymentFirstname" class="form-control" required>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="tradeInInfix">Tussenvoegsel</label>
              <input type="text" v-model="onlinepaymentForm.tussenvoegsel" name="onlinePaymentInfix" class="form-control" required>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="onlinePaymentLastname">Achternaam</label>
              <input type="text" v-model="onlinepaymentForm.achternaam"  name="onlinePaymentLastname" class="form-control" required>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col">
            <div class="form-group">
              <label for="onlinePaymentPhone">Telefoonnummer</label>
              <input type="text" name="onlinePaymentPhone" v-model="onlinepaymentForm.telefoonnummer"  class="form-control" required>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="onlinePaymentEmail">E-mailadres *</label>
              <input type="text" name="onlinePaymentEmail" v-model="onlinepaymentForm.email"  class="form-control" required>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col">
            <div class="form-group">
              <label for="onlinePaymentAddress">Adres</label>
              <input type="text" name="onlinePaymentAddress" v-model="onlinepaymentForm.adres"  class="form-control" required>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col">
            <div class="form-group">
              <label for="onlinePaymentCity">Plaats *</label>
              <input type="text" name="onlinePaymentCity" v-model="onlinepaymentForm.plaats"  class="form-control" required>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="onlinePaymentPostalCode">Postcode *</label>
              <input type="text" name="onlinePaymentPostalCode" v-model="onlinepaymentForm.postcode"  class="form-control" required>
            </div>
          </div>
        </div>

        <h4 class="mt-4">2. Gegevens aflevering</h4>
        <hr>
        Levering:
        <div class="form-check">
          <input class="form-check-input" value="ophalen" v-model="onlinepaymentForm.levering"  type="radio" name="onlinePaymentPickup" id="onlinePaymentPickup" checked>
          <label class="form-check-label" for="onlinePaymentPickup">
            Ophalen
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" value="bezorgen" v-model="onlinepaymentForm.levering"  type="radio" name="onlinePaymentPickup" id="onlinePaymentDeliver">
          <label class="form-check-label" for="onlinePaymentDeliver">
            Bezorgen
          </label>
        </div>

        <h4 class="mt-4">3. Betaalgegevens</h4>
        <hr>
        Betaling:
        <div class="form-check">
          <input class="form-check-input" type="radio" value="Overboeking" v-model="onlinepaymentForm.betaling" name="onlinePaymentTransfer" id="onlinePaymentTransfer" checked>
          <label class="form-check-label" for="onlinePaymentTransfer">
            Overboeking
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" value="Pinnen" v-model="onlinepaymentForm.betaling"  name="onlinePaymentTransfer" id="onlinePaymentPin">
          <label class="form-check-label" for="onlinePaymentPin">
            Pinnen bij aflevering
          </label>
        </div>

        <h4 class="mt-4">4. Afronden</h4>
        <hr>
        <div class="form-group mt-4">
          <label for="onlinePaymentQuestion">Eventuele vraag of opmerking</label>
          <textarea class="form-control" v-model="onlinepaymentForm.vraag"  name="onlinePaymentQuestion" rows="3" required></textarea>
        </div>
        Maak een keuze: Particulier of Zakelijk
        <div class="form-check">
          <input class="form-check-input" value="particulier" type="radio" v-model="onlinepaymentForm.particulierofzakelijk"  name="onlinePaymentPrivate" id="onlinePaymentPrivate" checked>
          <label class="form-check-label" for="onlinePaymentPrivate">
            Particulier
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" value="zakelijk" v-model="onlinepaymentForm.particulierofzakelijk" type="radio" name="onlinePaymentBusiness" id="onlinePaymentBusiness">
          <label class="form-check-label" for="onlinePaymentBusiness">
            Zakelijk
          </label>
        </div>

        <div class="form-check mt-4">
          <input type="checkbox" v-model="purchasetoestemming2" class="form-check-input" id="onlinePaymentCheck" required>
          <label class="form-check-label" for="onlinePaymentCheck">
            Hierbij geef ik {{ contact.name }} toestemming om mijn gegevens te gebruiken voor het verwerken van dit formulier
          </label>
        </div>

        <div class="form-check mt-4">
          <input type="checkbox" v-model="purchasetoestemming" class="form-check-input" id="onlinePaymentAgreement" required>
          <label class="form-check-label" for="onlinePaymentAgreement">
            Ik ga akkoord met de koop op afstand voorwaarden
          </label>
        </div>

        <button @click="submitpurchase($event)" type="submit" class="btn btn-primary mt-4">Versturen</button>
      </form>

    <component
        :locations="carStore.locations"
        :car="car"
        :cars="cars"
        :contact="contact"
        :employees="employees"
        :fieldOptions="fieldOptions"
        :class="'section-container section-container-' + i"
        v-for="(section, i) in sections"
        :key="i"
        :is="section"
        @setActiveTab="setActiveTab"/>

    <!-- Car info modal popup -->
    <div class="modal fade" id="carInfoModal" tabindex="-1" aria-labelledby="carInfoModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" style="margin-top: 110px !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="carInfoModalLabel">Alles over dit voertuig</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Sluiten"></button>
          </div>
          <div class="modal-body p-4">
            <ul class="nav mb-4 nav-pills" id="carInfo" role="tablist">
              <li class="nav-item me-2" role="presentation">
                <a class="nav-link active" id="carInfo-tab-1" data-bs-toggle="tab" href="#carInfo-tabs-1" role="tab" aria-controls="carInfo-tabs-1" aria-selected="true">Specificaties</a>
              </li>
              <li class="nav-item me-2" role="presentation">
                <a class="nav-link" id="carInfo-tab-2" data-bs-toggle="tab" href="#carInfo-tabs-2" role="tab" aria-controls="carInfo-tabs-2" aria-selected="false">Opties</a>
              </li>
              <li class="nav-item me-2" role="presentation">
                <a class="nav-link" id="carInfo-tab-3" data-bs-toggle="tab" href="#carInfo-tabs-3" role="tab" aria-controls="carInfo-tabs-3" aria-selected="false">Omschrijving</a>
              </li>
            </ul>

            <div class="tab-content" id="carInfo-content">
              <div class="tab-pane fade show active" id="carInfo-tabs-1" role="tabpanel" aria-labelledby="carInfo-tab-1">
                <h3 class="my-4">Alle specificaties</h3>
                <div class="row gx-3 gy-4">
                  <div class="col-sm-4" v-for="(item) in fieldOptions"  v-bind:key="item.key">
                    <div class="col-sm-4">
                      {{ item.title }}
                    </div>
                    <p class="fw-bold" v-if="car.extradata[item.key] && (item.key === 'btw_marge' && car.extradata[item.key] === 'B')">BTW</p>
                    <p class="fw-bold" v-if="car.extradata[item.key] && (item.key === 'btw_marge' && car.extradata[item.key] === 'M')">Marge</p>
                    <p class="fw-bold" v-if="car.extradata[item.key] && item.key !== 'btw_marge'" v-html="(item.prefix ?? '') + ' ' +(translateDict[car.extradata[item.key]] ?? car.extradata[item.key]) + ' ' +(item.suffix ?? '') "></p>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="carInfo-tabs-3" role="tabpanel" aria-labelledby="carInfo-tab-3">
                <h3 class="my-4">Omschrijving</h3>
                <p v-html="car.mappeddata.description">
                </p>
              </div>
              <div class="tab-pane fade" id="carInfo-tabs-2" role="tabpanel" aria-labelledby="carInfo-tab-2">
                <h3 class="my-4">Opties</h3>
                <ul class="optieslist" v-if="car.mappeddata.options" v-html="'<li>' + car.mappeddata.options.replace(/,/g, '</li><li>') + '</li>'"></ul>
                <p v-if="!car.mappeddata.options" v-html="car.mappeddata.description">
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn" data-bs-dismiss="modal">Sluiten</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { useCarStore } from '@/stores/car'
import ContactSection from '@/components/single/ContactSection.vue'
import RelatedCarsSection from "@/components/single/RelatedCarsSection.vue";
import DescriptionSection from "@/components/single/DescriptionSection.vue";
import InformationSection from "@/components/single/InformationSection.vue";
import SocialShare from "@/components/SocialShare";
import axios from 'axios'
import { Carousel, Slide, Navigation} from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
import FsLightbox from "fslightbox-vue/v3";
import { Tab } from 'bootstrap';

import { Form, Field, ErrorMessage } from 'vee-validate';

export default {
  setup() {
    const carStore = useCarStore()
    return { carStore }
  },
  updated() {

    if(this.$route.params.model !== this.currentmodel)
    {
      this.currentmodel = this.$route.params.model
      console.log('change')
      let id = this.$route.params.model;
      id = id.split('-');
      id = id[id.length - 1]
      console.log(id)
      //
      this.getData(id)

    }

  },
  components: {
    InformationSection,
    DescriptionSection,
    RelatedCarsSection,
    ContactSection,
    Carousel,
    Slide,
    Navigation,
    Form,
    SocialShare,
    Field,
    ErrorMessage,
    FsLightbox
  },
  props: {
    showShareButtons:Boolean
  },
  data() {
    return {
      fromArchive:'',
      currentmodel:'',
      translateDict: {
        "j":"Nieuw",
        "n":"Occasion",
        "B":"Benzine",
        "D":"Diesel",
        "B,E":"Benzine & Elektrisch",
        "D,E":"Diesel & Elektrisch",
        "E":"Elektrisch",
        "H":"Handgeschakeld",
        "A":"Automaat",
      },
      formattedpics:[],
      errors: {},
      currentSlide: 0,
      downpaymentForm: {
        merkmodel:'',
        naam:'',
        tel:'',
        email:''
      },
      estimateForm: {
        aanhef:'',
        voornaam:'',
        achternaam:'',
        tussenvoegsel:'',
        telefoonnummer:'',
        email:'',
        vraag:'',
        auto:'',
      },
      testdriveForm: {
        aanhef:'',
        voornaam:'',
        achternaam:'',
        tussenvoegsel:'',
        telefoonnummer:'',
        email:'',
        vraag:'',
        datum:'',
        tijd:'',
        auto:'',
        gewenstedatum:''
      },
      tradeinForm: {
        aanhef:'',
        voornaam:'',
        achternaam:'',
        tussenvoegsel:'',
        telefoonnummer:'',
        email:'',
        kenteken:'',
        kilometerstand:'',
        opmerkingen:'',
      },
      onlinepaymentForm: {
        aanhef:'',
        voornaam:'',
        achternaam:'',
        tussenvoegsel:'',
        telefoonnummer:'',
        email:'',
        adres:'',
        plaats:'',
        postcode:'',
        levering:'',
        auto:'',
        particulierofzakelijk:'',
        betaling:'',
        vraag:'',
      },
      tradeintoestemming:false,
      testdrivetoestemming:false,
      estimatetoestemming:false,
      purchasetoestemming:false,
      purchasetoestemming2:false,
      car:null,
      cars: null,
      contact: null,
      employees: null,
      filterOptions: null,
      settings: null,
      callToActions: null,
      sections: [],
      selectedForm: null,
      settingsCarousel: {
        itemsToShow: 1,
        snapAlign: 'center',
      },
      breakpoints: {
        100: {
          itemsToShow: 1,
          snapAlign: 'center',
        },
        // 700px and up
        700: {
          itemsToShow: 1,
          snapAlign: 'center',
        },
        // 1024 and up
        1024: {
          itemsToShow: 1,
          snapAlign: 'center',
        },
      },
      breakpointsSecond: {
        100: {
          itemsToShow: 2.2,
          snapAlign: 'left',
        },
        // 700px and up
        700: {
          itemsToShow: 3,
          snapAlign: 'center',
        },
        // 1024 and up
        1024: {
          itemsToShow: 4,
          snapAlign: 'center',
        },
      },
      toggler: false,
			slide: 1
    }
  },
  mounted()
  {
    let id = this.$route.params.model;
    this.currentmodel = id;
    id = id.split('-');
    id = id[id.length - 1]
    this.getData(id)

    var script_tag = document.createElement('script');
    script_tag.type = 'text/javascript';
    script_tag.src = window.ctcBuild + '/build-ctc-v3/js/ctc-app.js';
    document.body.appendChild(script_tag);

    var script_tag2 = document.createElement('script');
    script_tag2.type = 'text/javascript';
    script_tag2.src = window.ctcBuild + '/build-ctc-v3/js/ctc-vendor.js';
    document.body.appendChild(script_tag2);

  },
  methods: {
    getPdf() {
      window.location.href = window.crcApiUrl+"/pdf/"+this.car.id;
    },
    setActiveTab(tabId) {
      console.log('The tab fired.', tabId);
      this.$nextTick(() => {
        const tabToActivate = document.getElementById(tabId);
        if (tabToActivate) {
          new Tab(tabToActivate).show();
        } else {
          console.error('The tab element was not found.');
        }
      });
    },
    async init3d(theme, licenceplate, vin) {
        if (!licenceplate && !vin) {
          return false;
        }

        const checkURL = (url) => {
          return new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.onreadystatechange = function () {
              if (this.readyState === 4) {
                if (this.status === 200) {
                  let json = null;
                  try {
                    json = JSON.parse(this.responseText);
                  }
                  catch (e) {
                    console.log(e)
                  }
                  if (json && json.existing) {
                    resolve();
                  }
                  else reject();
                }
                else reject();
              }
            }
            xhr.send();
          });
        };
        if (licenceplate) {
          try {
            await checkURL('https://static-api.vivition.com/'+theme+'/licenceplate_vin/'+licenceplate+'_/existing.json');
            return true;
          }
          catch (e) {
            console.log(e)
            return false;
          }
        }
        try {
          await checkURL('https://static-api.vivition.com/'+theme+'/licenceplate_vin/_'+vin+'/existing.json');
          return true;
        }
        catch (e) {
          console.log(e)
          return false;
        }
    },

    InitVIVITION(licenceplate,vin,theme) {
      // Replace top div
      document.querySelector('#gallery').innerHTML = '<div '+((licenceplate !== "") ? 'data-licenceplate="'+licenceplate+'"' : '' )+' '+
          ((vin !== "") ? 'data-vin="'+vin+'"' : '' )+ 'data-theme="'+theme+'" class="vivition-player"></div>';
      document.querySelector('#gallery').classList.remove("largecontainer");

      // Replace thumb bar and add style at the end
      document.querySelector('#thumbnails').innerHTML = '<div class="vivition-thumbbar"></div>'+
          '<style>.vivition-player { height:0;padding-bottom: 66.66% } .vivition-thumbbar { height: 100px;margin-top:4px;width:100% } '+
          'body.vivition-style-rounded-square .crc-car-component-container .crc-img-container {height: auto;}'+
          'body.vivition-mobile .vivition-thumbbar { height: 65px; } @media(max-width:768px) { .vivition-thumbbar { height: 65px; } }.thumbcontainer { display: block !important }'+
          '.thumbnr {display: none !important;} .vivition-player {background: url(https://static-api.vivition.com/'+theme+'/licenceplate_vin/'+licenceplate+'_'+vin+'/initialphoto.jpg) no-repeat center / cover;}'+
          '@media screen and (min-width: 768px) {.vivition-player {background: url(https://static-api.vivition.com/'+theme+'/licenceplate_vin/'+licenceplate+'_'+vin+'/initialphoto_desktop.jpg) no-repeat center / cover; }}'+
          '</style>';

      // Insert the VIVITION Script at the bottom of the body
      if(document.querySelector('script[src="https://static-api.vivition.com/scripts/vivition.virtualvehicletour.js"]') === null)
      {
        // Insert the VIVITION Script at the bottom of the body
        var script = document.createElement("script");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", "https://static-api.vivition.com/scripts/vivition.virtualvehicletour.js");
        script.appendChild(document.createTextNode(''));
        document.body.appendChild(script);
      }
},
    submittradein(e) {
      e.preventDefault();
      if(this.tradeintoestemming == false)
      {
        alert('Je dient nog toestemming te geven')
        return;
      }
      this.tradeinForm.carid = this.car.mappeddata.carid;
      this.tradeinForm.auto = this.car.title+" - "+this.car.mappeddata.carid+" - "+this.car.mappeddata.plate
      this.tradeinForm.url = window.location.href;
      axios.post(window.crcBaseApiUrl+'form/'+window.conectApiKey, {form:this.tradeinForm,type:"Inruilen"}).then( ()  => {
        this.formSuccessMessage("Inruilen");
      });
    },
    submitestimate(e) {

      e.preventDefault();
      if(this.estimatetoestemming == false)
      {
        alert('Je dient nog toestemming te geven')
        return
      }
      this.estimateForm.carid = this.car.mappeddata.carid;
      this.estimateForm.auto = this.car.title+" - "+this.car.mappeddata.carid+" - "+this.car.mappeddata.plate
      this.estimateForm.url = window.location.href;
      axios.post(window.crcBaseApiUrl+'form/'+window.conectApiKey,{form:this.estimateForm,type:"Offerte"}).then( ()  => {
        this.formSuccessMessage("Offerte");
      });
    },
    submittestdrive(e) {
      e.preventDefault();
      if(this.testdrivetoestemming == false)
      {
        alert('Je dient nog toestemming te geven')
        return
      }
      this.testdriveForm.carid = this.car.mappeddata.carid;
      this.testdriveForm.auto = this.car.title+" - "+this.car.mappeddata.carid+" - "+this.car.mappeddata.plate
      this.testdriveForm.url = window.location.href;

      axios.post(window.crcBaseApiUrl+'form/'+window.conectApiKey,{form:this.testdriveForm,type:"Proefrit"}).then( ()  => {
        this.formSuccessMessage("Proefrit");
      });
    },
    submitpurchase(e) {
      e.preventDefault();

      if(this.purchasetoestemming == false || this.purchasetoestemming2 == false )
      {
        alert('Je dient nog toestemming te geven')
        return
      }
      this.onlinepaymentForm.carid = this.car.mappeddata.carid;
      this.onlinepaymentForm.auto = this.car.title+" - "+this.car.mappeddata.carid+" - "+this.car.mappeddata.plate
      this.onlinepaymentForm.url = window.location.href;
      axios.post(window.crcBaseApiUrl+'form/'+window.conectApiKey,{form:this.onlinepaymentForm,type:"Kopen"}).then( ()  => {
        this.formSuccessMessage("Kopen");
      });
    },
    formSuccessMessage(type)
    {
      window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: type+"_bedankt_form",
        ecommerce: {
          currency: "EUR",
          value: this.car.mappeddata.price,
      items: [
        {
          item_id: this.car.extradata.voertuignr_hexon,
          item_name: this.car.mappeddata.mode+" "+this.car.mappeddata.model,
          item_brand: this.car.mappeddata.brand,
          price: this.car.mappeddata.price,
      quantity: 1
    }
    ]
    }
    })

      alert('Het formulier is verzonden.')
    },
    sendForm() {
    },
    onSubmit() {
    },
    validateEmail(value) {
      if (!value) {
        return 'This field is required';
      }

      const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      if (!regex.test(value)) {
        return 'Dit is geen geldig e-mail adres.';
      }

      return true;
    },
    slideTo(val) {
      this.currentSlide = val
    },
    async getData(id)
    {

      var store = this.carStore;
      var cars = await store.getCars
      this.cars = cars
      this.car = cars.find(x => x.mappeddata.slug.replace(/\D/g,"") === id)
      var _this = this;
      var fulltitle = this.car.mappeddata.brand + " "+this.car.mappeddata.model + " "+this.car.mappeddata.type + " - " + this.car.company.name
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'virtualPageview',
        'pageUrl': window.location.href,
        'pageTitle': fulltitle
      });

      this.car.photos.forEach(function(obj) {
        _this.formattedpics.push(obj.original);

      });

      this.contact = store.contact
      this.settings = store.settings
      this.employees = store.employees
      if(this.car.location !== undefined)
      {
        this.employees = store.locationemployees[this.car.location]
      }
      this.callToActions = store.callToActions
      this.sections = store.sections
      this.fieldOptions = store.fieldOptions
      this.downpaymentForm.merkmodel = this.car.title

      const ogtitle = document.querySelector('meta[property="og:title"]');
      if(ogtitle === null)
        this.createMeta("og:title",this.car.title);
      if (ogtitle !== null) {
        ogtitle.content = fulltitle;
      }

      const pagetitle = document.querySelector('title');
      if (pagetitle !== null) {
        document.title = fulltitle+' - '+this.$parent.$parent.$root.$data.pagetitle;
      }

      var metaDescription =  this.car.mappeddata.brand.charAt(0).toUpperCase() + this.car.mappeddata.brand.slice(1) + ' ' + this.car.mappeddata.model + ' ' + this.car.mappeddata.type + '. Bouwjaar: ' + this.car.mappeddata.year + '. ' + this.car.extradata.accessoires.substring(0, 160);
      const ogdesc = document.querySelector('meta[property="og:description"]');
      if(ogdesc === null)
        this.createMeta("og:description", metaDescription);
      if (ogdesc !== null) {
        ogdesc.content = metaDescription;
      }
      const ogdesc2 = document.querySelector('meta[name="description"]');

      if(ogdesc2 === null)
      {
        var meta = document.createElement('meta');
        meta.name = "description";
        meta.content = metaDescription;
        document.getElementsByTagName('head')[0].appendChild(meta);
      }
      if (ogdesc2 !== null) {
        ogdesc2.content = metaDescription;
      }

      const ogimage = document.querySelector('meta[property="og:image"]');
      if(ogimage === null)
        this.createMeta("og:image",this.car.photos[0].large);
      if (ogimage !== null && this.car.photos.length > 0) {
        ogimage.content = this.car.photos[0].large;
      }

      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical !== null) {
        let type = this.car.mappeddata.type.replace(/[\W_]+/g,"-")
        let slug = this.car.mappeddata.slug.replace(/\D/g,"")
        var path = "/aanbod/"+ window.slugify(this.car.mappeddata.brand) + '-' + window.slugify(this.car.mappeddata.model) + '-' + window.slugify(type+ '-')  + window.slugify(slug);
        canonical.href = "https://"+window.location.hostname+path;
      }

      if(this.settings.viewer360 && this.settings.viewer360 === "1" && this.isValidPlate(this.car.mappeddata.plate))
      {
        const theme = this.settings.viewer360theme;
        const licenceplate = this.car.mappeddata.plate;
        const vin = '';
        var result = await _this.init3d(theme,licenceplate,vin);
        if(result)
          this.InitVIVITION(licenceplate,vin,theme)
      }
    },
    isValidPlate(plate) {
      const regex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6}$/;
      return regex.test(plate);
    },
    createMeta(key, value) {
      var meta = document.createElement('meta');
      meta.httpEquiv = key;
      meta.content = value;
      document.getElementsByTagName('head')[0].appendChild(meta);

    },
    scrollTo(element) {
      this.selectedForm = element
      setTimeout(() => this.$refs[element].scrollIntoView({ behavior: "smooth" }), 50);
    },
    scrollToCalculator(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },

    viewCar(car) {
      //this.$router.push({ name: 'Detail', params: { id: car.mappeddata.carid } })
      this.$router.push({ name: 'Detail', params: { carid: car.mappeddata.carid } })
      this.getData(car.mappeddata.carid)
      this.$refs['car'].scrollIntoView({ behavior: "smooth" })
    },
    formatPrice(price) {
      let euroformatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      });
      return euroformatter.format(price)
    },
    doPayment() {
      var thankyoupage = window.location.origin;
      axios.post(window.crcBaseApiUrl+'prepay-car/'+this.car.id,{redirectUrl: btoa(thankyoupage),form:this.downpaymentForm}).then( (response)  => {
        window.location.href = response.data;
      });
    },
    openLightboxOnSlide: function(number) {
				this.slide = number;
				this.toggler = !this.toggler;
			}
  }
}
</script>


<style scoped lang="scss">
.social-share-container {
  //display: none;
}
.social-share-container {
  order: 1;
}
.btn {

  order: 2;
}
@media only screen and (max-width:767px) {

  .back-btn{
    margin-bottom: 1.5rem !important;
  }
  .social-share-container {
    order: 2;
  }
  .btn {

    order: 1;
  }
}
@media screen and (min-width: 768px) {
  .social-share-container {
    display: block;
  }
  .back-btn{
    margin-bottom: 1rem !important;
  }
}
.car-sidebar-card hr:not([size]){
  background-color: black !important;
  margin-top: 25px;
  margin-bottom: 10px;
}
.finance-container-detail {
  margin-top: 5px;
  .finance-price {
    font-size: 1.3rem !important;
    background-color: #dc182c !important;
    border-radius: 50px;
    font-weight: 400;
    position: relative;
    top: 11px;
  }
  >a{
    color: #dc182c !important;
    text-decoration: underline;
    display: block !important;
    width: 100%;
    font-size: 14px;
    margin-top: -4px;
  }
}
.geld-lenen-kost-geld-container{
  text-align: center;
  padding: 4px;
  border: 2px solid black;
  width: 100%;
  margin-top: 45px;
  border-radius: 60px;
}
</style>
